import React from 'react'
import { LayoutBand, Row, Separator, Skeleton } from '@fs/zion-ui'

function ReportSkeleton() {
  return (
    <LayoutBand>
      <Skeleton.H1 />
      <Skeleton.H5 subheadingLineCount={1} />
      <Row>
        <Skeleton.Chip />
        <Skeleton.Chip />
        <Skeleton.Chip />
      </Row>
      <Separator />
      <Skeleton.Image height="300px" width="100%" />
    </LayoutBand>
  )
}

export default function ReportsSkeleton() {
  return (
    <>
      <LayoutBand>
        <Skeleton.H1 />
        <Skeleton.H5 subheadingLineCount={1} />
      </LayoutBand>
      <Separator />
      <ReportSkeleton />
      <Separator size="md" />
      <ReportSkeleton />
      <Separator size="md" />
      <ReportSkeleton />
    </>
  )
}
